import EventDispatcher from '../common/EventDispatcher';
import * as THREE from 'three';
import { Global } from '../common/global';

export default class GameControl {
  constructor(scene) {
    this.scene = scene;

    // config
    this.minSwipeDistancePx = 20; // pixels required to count as a swipe

    // state
    this.isTouching = false;
    this.touchStartX = 0;
    this.lastX = 0;

    // event system
    this.events = null;

    // bound handlers so we can remove listeners later
    this._onTouchStartBound = this.onTouchStart.bind(this);
    this._onMoveBound = this.onMove.bind(this);
    this._onTouchEndBound = this.onTouchEnd.bind(this);
    this._onKeyDown = this.onKeyDown.bind(this);

    document.addEventListener('touchstart', this._onTouchStartBound, {
      passive: true,
    });
    document.addEventListener('touchmove', this._onMoveBound, {
      passive: true,
    });
    document.addEventListener('touchend', this._onTouchEndBound);

    // Mouse events (desktop)
    document.addEventListener('mousedown', this._onTouchStartBound);
    document.addEventListener('mousemove', this._onMoveBound);
    document.addEventListener('mouseup', this._onTouchEndBound);
    document.addEventListener('keydown', this._onKeyDown);
  }

  init() {
    // EventDispatcher instance
    this.events = EventDispatcher.getObj();

    // Touch events
  }
  onKeyDown(event) {
    if (!Global.isGameActive) return;
    if (event.key === 'ArrowLeft') {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'hide_intro',
          data: {},
        },
      });
      this.events.dispatchEvent({
        type: 'PLAYER_EVENTS',
        message: {
          event_type: 'on_swipe',
          data: {
            direction: 'Left', // 'Left' or 'Right'
          },
        },
      });
    }
    if (event.key === 'ArrowRight') {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'hide_intro',
          data: {},
        },
      });
      this.events.dispatchEvent({
        type: 'PLAYER_EVENTS',
        message: {
          event_type: 'on_swipe',
          data: {
            direction: 'Right', // 'Left' or 'Right'
          },
        },
      });
    }
  }
  onTouchStart(event) {
    // support both touch and mouse events
    const isTouch = event.type.startsWith('touch');
    const clientX = isTouch ? event.touches[0].clientX : event.clientX;

    this.isTouching = true;
    this.touchStartX = clientX;
    this.lastX = clientX;
  }

  onMove(event) {
    if (!this.isTouching) return;

    const isTouch = event.type.startsWith('touch');
    const clientX = isTouch ? event.touches[0].clientX : event.clientX;

    this.lastX = clientX;
  }

  onTouchEnd(event) {
    if (!this.isTouching) return;

    // compute overall delta
    const deltaX = this.lastX - this.touchStartX;

    // determine direction with a threshold to filter taps
    let direction = null;
    if (deltaX > this.minSwipeDistancePx) direction = 'Right';
    else if (deltaX < -this.minSwipeDistancePx) direction = 'Left';
    else direction = 'Tap';

    if (!Global.isGameActive) return;
    // Emit only swipe directions (Left/Right). Change if you want to include taps.
    if (direction === 'Left' || direction === 'Right') {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'hide_intro',
          data: {},
        },
      });
      this.events.dispatchEvent({
        type: 'PLAYER_EVENTS',
        message: {
          event_type: 'on_swipe',
          data: {
            direction, // 'Left' or 'Right'
            distance: deltaX, // raw pixel distance (positive = right, negative = left)
          },
        },
      });
    }

    // reset state
    this.isTouching = false;
    this.touchStartX = 0;
    this.lastX = 0;
  }

  // Clean up listeners
  dispose() {
    document.removeEventListener('touchstart', this._onTouchStartBound);
    document.removeEventListener('touchmove', this._onMoveBound);
    document.removeEventListener('touchend', this._onTouchEndBound);

    document.removeEventListener('mousedown', this._onTouchStartBound);
    document.removeEventListener('mousemove', this._onMoveBound);
    document.removeEventListener('mouseup', this._onTouchEndBound);
  }
}
